import { createPortalSlot } from './PortalSlot';

export const TopBarPaneSlot = createPortalSlot();
